export const TRI_LOGO =
  "https://customer-assets-jai6qajn.emergentagent.net/job_frontline-score/artifacts/qnrptdi2_TRI-logo.webp";

export const APP_NAME = "Pragati Assessment Tool";
export const ORG_NAME = "Transform Rural India";
